import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-motorbutton',
  templateUrl: './motorbutton.component.html',
  styleUrls: ['./motorbutton.component.css']
})
export class MotorbuttonComponent implements OnInit {

  @Input() loading;
  @Input() power = false;
  @Input() rpm = 0;
  @Output() outFile = new EventEmitter();
  @Output() user_click = new EventEmitter();
  @ViewChild('file_input') el: ElementRef;

  constructor() { }

  ngOnInit() {
  }

  mode(event) {
    this.user_click.emit(event);
  }

  disc() {
    this.el.nativeElement.click();
  }

  new_file(file) {
    const target = file.currentTarget;
    const audio = target.files[0];
    this.outFile.emit(audio);
  }

}



// WEBPACK FOOTER //
// ./src/app/motorbutton/motorbutton.component.ts